"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

/* The rows of a clinic's contact card (D-11), on the secure link, in the
 * settings preview and in the patient app: only the fields the clinic
 * filled in, in a fixed order, then Directions: the saved Google Maps link,
 * or a Maps search of the address. The server already refused anything but
 * https links; a link that isn't https is still dropped here. */












// No ?, &, % or , so a mailto: link can't add a subject, body or copy.
const EMAIL = /^[^\s@<>"?&%,]+@[^\s@<>"?&%,]+$/

// An https link as its host and the rest. A pattern, not URL: React
// Native's URL doesn't implement protocol or hostname. The host has no
// backslash, and anything after it starts with /, ? or #, so no @ (userinfo)
// comes before the path.
const HTTPS = /^https:\/\/([^\s/?#@\\]+)(\/[^\s?#]*)?(\?[^\s#]*)?(#\S*)?$/i

const httpsUrl = (value) => {
  const match = value ? HTTPS.exec(value) : null
  if (!match) return null
  return { href: match[0], host: match[1].toLowerCase(), pathname: match[2] || '/', search: match[3] || '' }
}

const mapsSearch = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`

 const contactRows = (contact) => {
  const rows = []
  const phone = _optionalChain([contact, 'access', _ => _.Phone, 'optionalAccess', _2 => _2.trim, 'call', _3 => _3()])
  const email = _optionalChain([contact, 'access', _4 => _4.Email, 'optionalAccess', _5 => _5.trim, 'call', _6 => _6()])
  const address = _optionalChain([contact, 'access', _7 => _7.Address, 'optionalAccess', _8 => _8.trim, 'call', _9 => _9()])
  const website = httpsUrl(_optionalChain([contact, 'access', _10 => _10.Website, 'optionalAccess', _11 => _11.trim, 'call', _12 => _12()]))
  const maps = httpsUrl(_optionalChain([contact, 'access', _13 => _13.MapsURL, 'optionalAccess', _14 => _14.trim, 'call', _15 => _15()]))

  if (phone) {
    const dial = phone.replace(/[^\d+]/g, '')
    rows.push({ kind: 'call', label: 'Call', value: phone, ...(dial && { href: `tel:${dial}` }), external: false })
  }
  if (email && EMAIL.test(email)) {
    rows.push({ kind: 'email', label: 'Email', value: email, href: `mailto:${email}`, external: false })
  }
  if (website) {
    const shown = (website.host + website.pathname + website.search).replace(/\/$/, '')
    rows.push({ kind: 'website', label: 'Website', value: shown, href: website.href, external: true })
  }
  if (address) rows.push({ kind: 'address', label: 'Address', value: address })
  if (maps) {
    rows.push({ kind: 'directions', label: 'Directions', value: 'Open in Google Maps', href: maps.href, external: true })
  } else if (address) {
    rows.push({ kind: 'directions', label: 'Directions', value: 'Search Google Maps for this address', href: mapsSearch(address), external: true })
  }
  return rows
}; exports.contactRows = contactRows
